import React from 'react';
import styles from './DropdownOptionsListItem.module.scss';
import Check from '../../../Icons/Check';
import { type IOption } from '../../models/IOption';

export interface IDropdownOptionsListItem {
  id: string;
  option: IOption;
  index: number;
  isSelected: boolean;
  onOptionClick: (option: IOption) => void;
  optionStyle: 'OneLine' | 'TwoLine';
  optionRef: (el: HTMLLIElement | null) => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLLIElement>, index: number) => void;
}

export default function DropdownOptionsListItem({
  id,
  option,
  index,
  isSelected,
  onOptionClick,
  optionStyle,
  optionRef,
  onKeyDown,
}: IDropdownOptionsListItem) {
  const optionClasses = [optionStyle === 'TwoLine' ? styles.twoLineOption : '', styles.option].join(
    ' ',
  );

  return (
    <li
      className={optionClasses}
      id={`${id}-option-${option.value}`}
      role="option"
      tabIndex={0}
      ref={optionRef}
      aria-selected={isSelected}
      onClick={() => {
        onOptionClick(option);
      }}
      onKeyDown={(e) => {
        onKeyDown(e, index);
      }}
    >
      <span className={isSelected ? styles.selectedOptionText : ''}>{option.text}</span>
      {isSelected ? <Check /> : null}
    </li>
  );
}
